//Slideshow Alternative
//Activate the Text Animation when that section of the page is visible to the screen
if (document.getElementById('slide-animation-block-text-container-id')){
    $(window).scroll(function() {
        let hT = $('#slide-animation-block-text-container-id').offset().top,
            hH = $('#slide-animation-block-text-container-id').outerHeight(),
            wH = $(window).height(),
            wS = $(this).scrollTop();
        if (wS < (hT+hH-wH)){
            $(".slide-animation-block-text").css("display", "flex")
        }
    });
}


//Alternative Slideshow Slider
if(document.getElementById('slideshow-progress-image-wrapper-id')){

    const imageSlideWrapper = document.getElementById('slideshow-progress-image-wrapper-id');
    const imageSlideContainer = document.getElementById('slideshow-progress-image-container-id');
    const progressBar = document.getElementById('slider-progress-bar-inner-id');

    let currentSlideClientProgress = (imageSlideWrapper.clientWidth/imageSlideWrapper.scrollWidth) * 100;
    progressBar.style.width = `${currentSlideClientProgress}%`;

    window.addEventListener('resize', ()=>{
        currentSlideClientProgress = (imageSlideWrapper.clientWidth/imageSlideWrapper.scrollWidth) * 100;
        progressBar.style.width = `${currentSlideClientProgress}%`;
    })

    let sliderGrabbed = false;

    imageSlideWrapper.addEventListener('scroll', (event)=>{
        progressBar.style.width = `${slideshowProgressBarScrollPercentage()}%`;
    })

    imageSlideContainer.addEventListener('mousedown', (e)=>{
        sliderGrabbed = true;
        imageSlideContainer.style.cursor = "grabbing";
        e.preventDefault();
    })

    imageSlideContainer.addEventListener('mouseup', ()=>{
        sliderGrabbed = false;
        imageSlideContainer.style.cursor = "grab";
    })
    imageSlideContainer.addEventListener('mouseleave', () => {
        sliderGrabbed = false;
    })
    imageSlideContainer.addEventListener('mousemove', (e)=>{
        if(sliderGrabbed) {
            imageSlideWrapper.scrollLeft -= e.movementX;
        }
    })

    function slideshowProgressBarScrollPercentage() {
        return((imageSlideWrapper.scrollLeft  / imageSlideWrapper.scrollWidth) * 100 + currentSlideClientProgress)
    }
}


//Lightbox Video
if(document.getElementById("our-story-video-container-id")) {
   //Play Video
   let OurStoryVideo = document.getElementsByClassName('our-story-video')[0];
   OurStoryVideo.addEventListener('click', ()=>{ //Pause and Play Video
       if(OurStoryVideo.paused){
           OurStoryVideo.play()
           $("#icon-video-play-btn-id").fadeIn()
           $("#icon-video-play-btn-id").fadeOut()
       }else{
           OurStoryVideo.pause()
           $("#icon-video-play-btn-id").fadeIn()
       }
   })
   //The PLay button has an higher css z-index than the video so 
   //Incase the play button is clicked directly, we play the video
   let storyPlayVideoBtn = document.getElementsByClassName('icon-video-play-btn')[0];
   storyPlayVideoBtn.addEventListener('click', ()=>{ //Pause and Play Video
       if(OurStoryVideo.paused){
           OurStoryVideo.play()
           $("#icon-video-play-btn-id").fadeIn()
           $("#icon-video-play-btn-id").fadeOut()
       }else{
           OurStoryVideo.pause()
           $("#icon-video-play-btn-id").fadeIn()
       }
   })

   document.body.addEventListener('click', (evt)=>{
       let videoLightBoxContainer = document.getElementById('our-story-video-container-id');
       let videoLightBox = document.getElementsByClassName('our-story-video')[0];
       let posterVideoContainer = document.getElementsByClassName('our-story-video-poster-wrapper')[0];


       let posterPositon = posterVideoContainer.getBoundingClientRect();
       let posterTotalWidthPosition = Number(posterPositon.left.toFixed()) + Number(posterPositon.width);
       let posterTotalHeightPosition = Number(posterPositon.top.toFixed()) + Number(posterPositon.height);

       let videoPosition = OurStoryVideo.getBoundingClientRect();
       let videoTotalWidthPosition = Number(videoPosition.left.toFixed()) + Number(videoPosition.width);
       let videoTotalHeightPosition = Number(videoPosition.top.toFixed()) + Number(videoPosition.height);

       //Check if the user clicks the Video Poster 
       if (window.getComputedStyle(videoLightBoxContainer, null).display === "none" &&
           evt.clientX >= Number(posterPositon.left.toFixed()) &&
           evt.clientX < posterTotalWidthPosition &&
           evt.clientY >= Number(posterPositon.top.toFixed()) &&
           evt.clientY < posterTotalHeightPosition
       ){
           $("#our-story-video-container-id").fadeIn("slow"); //display video if the user clicks the video poster

       }else if(videoLightBoxContainer.style.display === "block"){//Check if the video is currenly visible
           //Check if the user clicks the video
           //if True, do nothing
           //if False, it means the user is clicking outside the video
           //if False, close the video
           if(
               evt.clientX >= Number(videoPosition.left.toFixed()) && //check if the 
               evt.clientX < videoTotalWidthPosition &&
               evt.clientY >= Number(videoPosition.top.toFixed()) &&
               evt.clientY < videoTotalHeightPosition
           ){
               //Do nothing when the video is being clicked
           }else{
               //Stop the Video and Fade out the video if the user clicks outside the video 
               OurStoryVideo.pause();
               OurStoryVideo.currentTime = 0;
               
               $("#our-story-video-container-id").slideUp("slow");
               $("#our-story-video-container-id").fadeOut();
           }
       }
   });
}


//CHANGE IMAGE OF THE LOGIN PAGE WHEN FORGET PASSWORD IS CLICKED
if(document.getElementById('login_section_id')){
    window.addEventListener('load', loadAppropriateImage);
    window.addEventListener('hashchange', loadAppropriateImage);

    let loginImage = document.getElementById('load-login-image');
    let recoverPasswordImage = document.getElementById('recover-password-image');

    function loadAppropriateImage(){
        let urlPath = window.location.href;
        if(urlPath.indexOf('recover') !== -1) {
            loginImage.style.display = "none";
            recoverPasswordImage.style.display = "block";
        }else {
            loginImage.style.display = "block";
            recoverPasswordImage.style.display = "none";
        }
    }
}

//MENU LIST SECTION 
const switchActiveWrapper = (x) =>{

    if(getActiveBtnWrapper().indexOf(x) === -1){
        $('#'+getActiveBtnWrapper()).fadeOut("fast");
        document.getElementById(getActiveBtnWrapper()).classList.remove('btn-active-window-wrapper');
        document.getElementById(getActiveButton()).classList.remove('active-btn-window');

        document.getElementById(x+'-btn-wrapper-overall').classList.add('btn-active-window-wrapper');
        document.getElementById('btn-'+x+'-dog').classList.add('active-btn-window');
        $('#'+x+'-btn-wrapper-overall').fadeIn("fast");

    }
}
const getActiveBtnWrapper = () =>{
    let activeWrapper = document.getElementsByClassName('btn-active-window-wrapper')[0];
    return activeWrapper.id;
}
const getActiveButton = () =>{
    let activeButton = document.getElementsByClassName('active-btn-window')[0];
    return activeButton.id;
}
const displayMenuPopup = (x) =>{
    $('#'+x+'-menu-popup-wrappper-id').fadeIn('slow');
    document.getElementById('btn-'+x+'-dog').classList.add('active-menu-popup-btn');
    document.getElementById('btn-'+x+'-dog').classList.remove('disable-menu-popup-btn');
}
const disableMenuPopup = (x) =>{
    $('#'+x+'-menu-popup-wrappper-id').fadeOut('slow');
    document.getElementById('btn-'+x+'-dog').classList.remove('active-menu-popup-btn');
    document.getElementById('btn-'+x+'-dog').classList.add('disable-menu-popup-btn');
}

//ABOUT US -- OUR STORY SECTION
if (document.getElementById('abt-us-achievement-list-wrapper-id')) {
     //Setting the custom color

     let aboutListWrapper = document.getElementsByClassName('abt-list-319-wrapper');
     Array.from(aboutListWrapper).forEach((aboutList, index)=>{
         let colorData = aboutList.getAttribute('data-color-attribute');
 
         //getting the "abt-321-base-circle" class so we can change the background color
         let baseCircle = aboutList.children[0].children[1].children[0];
         baseCircle.style.backgroundColor = colorData;
     })
 
 
     let storyText = document.getElementsByClassName('abt-321-achievement-text');
     Array.from(storyText).forEach((eachText, index)=>{
 
         //getting the text
         let baseText = eachText.children[0];
 
         let randomNumber = Math.floor(Math.random() * 3) + 1; //Generates random numbers from 1 - 3
         
         let arrayText = baseText.textContent.split(' ');
         let selectedText = arrayText.slice(0,2).join(' ');
         let remainingText = arrayText.slice(2,arrayText.length).join(' ');
 
         
         baseText.innerHTML = "<span>"+selectedText+"</span>"+remainingText;
 
         let colorData = aboutListWrapper[index].getAttribute('data-color-attribute');
 
         baseText.children[0].style.backgroundColor = colorData;
     })
}

//OPEN LINKS IN NEW TAB
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

if(document.getElementById('video-series-id')) {

    let paentVideoCon = document.getElementsByClassName('video-series-indi-video-container')[0];

    let kids = paentVideoCon.childNodes; 
    let numkids = kids.length; 
    for(let i = numkids-1; i >= 0; i--) {  // Loop through them backwards
        let c = paentVideoCon.removeChild(kids[i]);    // Remove a child
        paentVideoCon.appendChild(c);                  // Put it back at its new position
    }
    let parentVideoWrapper = document.getElementsByClassName('video-series-indi-video-wrapper')[0];
    parentVideoWrapper.style.display = "inline-block";


    let apiKey = 'AIzaSyA4txsyDAado2w5hD0Hd7dEWO94agLOOEM';
    let iframePlayerVS = document.getElementById('vs-popup-iframe-itself-id');
    let iframeVideoTitleVS = document.getElementById('vs-popup-video-text-title-id');
    let iframeVideoDescriptionVS = document.getElementById('vs-popup-video-text-desc-id');
    let iframeVideoViewsCountVS = document.getElementById('vs-popup-video-text-views-count-id');



    const fetchYoutubeData = (fetchUrl, eachvideoCon) => {
        let videotitle, videoDescription, videoViews;

        let request = new XMLHttpRequest()
        request.open('GET', fetchUrl, true)
        request.onload = function () {
        // Begin accessing JSON data here
        let data = JSON.parse(this.response)
            if (request.status >= 200 && request.status < 400) {
                console.log(data)
                    videotitle = data.items['0'].snippet.title;
                    videoDescription = data.items['0'].snippet.description;
                    videoViews = data.items['0'].statistics.viewCount;

                    //Insert Title
                    eachvideoCon.children[0].children[1].textContent = videotitle;
                    //Insert Description
                    eachvideoCon.children[0].children[2].textContent = videoDescription;
                    //Insert Video View Count
                    eachvideoCon.setAttribute('data-video-views', videoViews);

            } else {
                console.log('error')
            }
        }
        request.send()
    }

    let videoContainer = document.getElementsByClassName('each-video-series-indi-container');
    Array.from(videoContainer).forEach(function  (eachvideoCon, index){
        let videoID = eachvideoCon.getAttribute('data-video-link');
        let fetchUrl = 'https://www.googleapis.com/youtube/v3/videos?key='+apiKey+'&part=snippet,statistics&id='+videoID;
        fetchYoutubeData(fetchUrl, eachvideoCon);

        eachvideoCon.addEventListener('click', ()=>{
            let videoTitleS = eachvideoCon.children[0].children[1].textContent;
            let videoDescriptionS = eachvideoCon.children[0].children[2].textContent;
            let videoViews =  eachvideoCon.getAttribute('data-video-views');

            iframePlayerVS.src = 'https://www.youtube.com/embed/'+videoID+'?rel=0';
            iframePlayerVS.src = iframePlayerVS.src;
            $("#popup-video-player-wrapper-id").fadeIn();

            iframeVideoTitleVS.textContent = videoTitleS;
            iframeVideoDescriptionVS.textContent = videoDescriptionS;
            iframeVideoViewsCountVS.textContent = videoViews+" Views";
        })
    })


    document.body.addEventListener('click', (evt)=>{
        let videoLightBoxContainer = document.getElementById('popup-video-player-wrapper-id');
        let videoLightBox = document.getElementsByClassName('vs-ini-popup-video-player')[0];
    

        let videoPosition = videoLightBox.getBoundingClientRect();
        let videoTotalWidthPosition = Number(videoPosition.left.toFixed()) + Number(videoPosition.width);
        let videoTotalHeightPosition = Number(videoPosition.top.toFixed()) + Number(videoPosition.height);
        if(videoLightBoxContainer.style.display === "block"){//Check if the video is currenly visible
            //Check if the user clicks the video
            //if True, do nothing
            //if False, it means the user is clicking outside the video
            //if False, close the video
            if(
                evt.clientX >= Number(videoPosition.left.toFixed()) && //check if the 
                evt.clientX < videoTotalWidthPosition &&
                evt.clientY >= Number(videoPosition.top.toFixed()) &&
                evt.clientY < videoTotalHeightPosition
            ){
                //Do nothing when the video is being clicked
            }else{
                //Stop the Video and Fade out the video if the user clicks outside the video 
                iframePlayerVS.src = iframePlayerVS.src;
                $("#popup-video-player-wrapper-id").fadeOut();

            }
        }
    });


    //SEARCH VIDEO FUNCTION
    const inputID = document.getElementById('search-input-id');

    inputID.addEventListener('input', ()=>{
        let totalChild = videoContainer.length;
        let search = 0;
        Array.from(videoContainer).forEach(function  (eachvideoCon, index){
            let videoTitleS = eachvideoCon.children[0].children[1].textContent;
            let videoDescriptionS = eachvideoCon.children[0].children[2].textContent;

            let regInput = new RegExp(inputID.value, 'i');

            if(videoTitleS.search(regInput) !== -1 ||
                videoDescriptionS.indexOf(regInput) !== -1
            ){
                eachvideoCon.style.display = "inline-block"
            }else{
                search = search + 1;
                eachvideoCon.style.display = "none"

                if (Number(search) === Number(totalChild)){
                    $("#no-search-result-wrapper-id").fadeIn('fast');
                }else{
                    $("#no-search-result-wrapper-id").fadeOut('fast');
                }
            }
        })

    })

}  